import {isNotNil} from 'ramda';

import {LeasingCommonParameters, SaveSaleVehicleLeasingBody} from '@dms/api/vehicle';

import {isValidMoneyAmount} from './isValidMoneyAmount';

type LeasingMoneyKey = {
  [TKey in keyof LeasingCommonParameters]-?: LeasingCommonParameters[TKey] extends {
    amount: string;
  } | null
    ? TKey
    : never;
}[keyof LeasingCommonParameters];

/** Every money amount the common-parameters panel lets the user type into a leasing body. */
const LEASING_MONEY_KEYS: LeasingMoneyKey[] = [
  'listPrice',
  'downPayment',
  'excessMileageCost',
  'underMileageCredit',
  'vehicleTransferAmount',
  'vehicleRegistrationAmount',
  'vehicleDeliveryAmount',
  'maintenanceMonthly',
  'wearMonthly',
  'maintenanceAndWearMonthly',
  'vehicleTaxMonthly',
  'liabilityInsuranceMonthly',
  'liabilityInsuranceDeductible',
  'comprehensiveInsuranceMonthly',
  'comprehensiveInsuranceDeductible',
  'tiresMonthly',
  'inspectionMonthly',
  'returnValueInsuranceMonthly',
];

export function findInvalidLeasingMoneyKey(vehicleLeasingBody: SaveSaleVehicleLeasingBody) {
  const {listPrice, downPayment} = vehicleLeasingBody.commonParameters;

  if (isNotNil(listPrice) && isNotNil(downPayment) && listPrice.currency !== downPayment.currency) {
    return 'downPayment';
  }

  return LEASING_MONEY_KEYS.find(
    (key) => !isValidMoneyAmount(vehicleLeasingBody.commonParameters[key])
  );
}
